import React from 'react';
import { Skeleton, Divider } from '@mui/material';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import colors from 'src/utils/colors';

const skeletonSx = { backgroundColor: colors.graysPrimary };

const ProfileSettingsSkeleton = () => {
  return (
    <BasePageContainer>
      <Flex flexDirection="column">
        {/* Header: Content Profile */}
        <Flex justifyContent="space-between" alignItems="center">
          <Skeleton variant="text" width={180} height={32} sx={skeletonSx} />
        </Flex>
        {/* Description text */}
        <Skeleton variant="text" width={520} height={20} sx={{ marginTop: '8px', ...skeletonSx }} />

        {/* Profile Name section */}
        <Flex flexDirection="column" sx={{ marginTop: '32px' }}>
          <Skeleton variant="text" width={100} height={20} sx={skeletonSx} />
          <Skeleton variant="rectangular" width="100%" height={40} sx={{ marginTop: '8px', borderRadius: '4px', ...skeletonSx }} />
        </Flex>

        <Divider sx={{ margin: '32px 0' }} />

        {/* Content Limits section */}
        <Flex flexDirection="column">
          <Skeleton variant="text" width={280} height={24} sx={skeletonSx} />
          <Skeleton variant="text" width={480} height={20} sx={{ marginTop: '4px', ...skeletonSx }} />
          <Flex gap={48} sx={{ marginTop: '16px' }}>
            {[...Array(4)].map((_, i) => (
              <Flex key={i} flexDirection="column" gap={8}>
                <Skeleton variant="text" width={80} height={20} sx={skeletonSx} />
                <Skeleton variant="rectangular" width={82} height={36} sx={{ borderRadius: '4px', ...skeletonSx }} />
              </Flex>
            ))}
          </Flex>
        </Flex>

        {/* AI Custom Instructions section */}
        <Flex flexDirection="column" sx={{ marginTop: '48px' }}>
          <Skeleton variant="text" width={180} height={24} sx={skeletonSx} />
          <Skeleton variant="text" width={520} height={20} sx={{ marginTop: '4px', ...skeletonSx }} />
          <Skeleton variant="rectangular" width="100%" height={122} sx={{ marginTop: '16px', borderRadius: '4px', ...skeletonSx }} />
        </Flex>

        {/* Dominant Voice & Tone section */}
        <Flex gap={48} sx={{ marginTop: '48px' }}>
          {[...Array(2)].map((_, i) => (
            <Flex key={i} flexDirection="column" gap={8} sx={{ flex: 1 }}>
              <Skeleton variant="text" width={120} height={20} sx={skeletonSx} />
              <Skeleton variant="rectangular" width="100%" height={36} sx={{ borderRadius: '4px', ...skeletonSx }} />
            </Flex>
          ))}
        </Flex>

        <Divider sx={{ margin: '32px 0' }} />

        {/* Keywords section */}
        <Flex flexDirection="column">
          <Skeleton variant="text" width={100} height={24} sx={skeletonSx} />
          <Skeleton variant="text" width={400} height={20} sx={{ marginTop: '4px', ...skeletonSx }} />
          <Flex gap={24} sx={{ marginTop: '16px' }}>
            {[...Array(2)].map((_, i) => (
              <Flex key={i} flexDirection="column" gap={8} sx={{ flex: 1 }}>
                <Skeleton variant="text" width={140} height={20} sx={skeletonSx} />
                <Skeleton variant="rectangular" width="100%" height={80} sx={{ borderRadius: '4px', ...skeletonSx }} />
              </Flex>
            ))}
          </Flex>
        </Flex>

        <Divider sx={{ margin: '32px 0' }} />

        {/* Requirements section */}
        <Flex flexDirection="column">
          <Skeleton variant="text" width={120} height={24} sx={skeletonSx} />
          <Skeleton variant="text" width={380} height={20} sx={{ marginTop: '4px', ...skeletonSx }} />
          <Skeleton variant="rectangular" width="100%" height={100} sx={{ marginTop: '16px', borderRadius: '4px', ...skeletonSx }} />
        </Flex>

        {/* Footer buttons */}
        <Flex justifyContent="space-between" sx={{ marginTop: '64px' }}>
          <Skeleton variant="rectangular" width={80} height={36} sx={{ borderRadius: '4px', ...skeletonSx }} />
          <Skeleton variant="rectangular" width={80} height={36} sx={{ borderRadius: '4px', ...skeletonSx }} />
        </Flex>
      </Flex>
    </BasePageContainer>
  );
};

export default ProfileSettingsSkeleton;


